import '../styles/CustomersSurveyReport.scss';
import { Button, Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import Multiselect from 'multiselect-react-dropdown';
import UniDatePickerRange from '../components/UniDatePickerRange/UniDatePickerRange';
import filterIcon from '../assets/icons/filter.svg';
import graph from '../assets/icons/graph.svg';
import documentExcel from '../assets/icons/document-excel.svg';
import ThreeStarsPointingFingerGreen from '../assets/icons/3-stars-pointing-finger-green.svg';
import FaceAngryRed from '../assets/icons/face-angry-red.svg';
import FaceUpsetOrange from '../assets/icons/face-upset-orange.svg';
import FaceNeutralYellow from '../assets/icons/face-neutral-yellow.svg';
import FaceHappyLightgreen from '../assets/icons/face-happy-light-green.svg';
import FaceMarvelousGreen from '../assets/icons/face-marvelous-green.svg';
import StarYellow from '../assets/icons/star-yellow.svg';
import UserGroup from '../assets/icons/user-group.svg';
import EyeBlack from '../assets/icons/eye-black.svg';
import { getAllCustomer} from '../services/customerService';
import {GetReportData, GetFileReport, RequestReportData, ResponseReportData} from '../services/customersSurveyReportService';
import UniModal from '../components/UniModal/UniModal';
import { faSort, faSortAmountDown, faSortAmountUp, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import UniWidgetColumnReportTwo, { UniWidgetColumnTwoOptions } from '../components/UniWidgetColumnReportTwo/UniWidgetColumnReportTwo';
import UniWidgetSummaryReportTwo from '../components/UniWidgetSummaryReportTwo/UniWidgetSummaryReportTwo';
import { CustomSegmentLabelPosition } from 'react-d3-speedometer';
import UniPagination from '../components/UniPagination/UniPagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type MultiselectOptions = {
    id: string
    name: string,
};

const CustomersSurveyReport = () =>{
    const { i18n, t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [periodValue, setPeriodValue] = useState<string | null>('');
    const [startDate, setStartDate] = useState<Date | any>(undefined);
    const [endDate, setEndDate] = useState<Date | any>(undefined);
    const [showRangeDates, setShowRangeDates] = useState(false);
    const [currentTab, setCurrentTab] = useState(1);
    const [currentSelectedCsatFilter, setCurrentSelectedCsatFilter] = useState(new Date().getFullYear());
    const [currentSelectedNpsFilter, setCurrentSelectedNpsFilter] = useState(new Date().getFullYear());
    const [optionsCustomers, setOptionsCustomers] = useState<MultiselectOptions[]>([]);
    const months = [
        { id: '1', name: 'customersSurveyReportPage.jan' },
        { id: '2', name: 'customersSurveyReportPage.feb' },
        { id: '3', name: 'customersSurveyReportPage.mar' },
        { id: '4', name: 'customersSurveyReportPage.apr' },
        { id: '5', name: 'customersSurveyReportPage.may' },
        { id: '6', name: 'customersSurveyReportPage.jun' },
        { id: '7', name: 'customersSurveyReportPage.jul' },
        { id: '8', name: 'customersSurveyReportPage.aug' },
        { id: '9', name: 'customersSurveyReportPage.sep' },
        { id: '10', name: 'customersSurveyReportPage.oct' },
        { id: '11', name: 'customersSurveyReportPage.nov' },
        { id: '12', name: 'customersSurveyReportPage.dec' }
    ];
    const speedometerCustomerSegmentLabels = [
        {
            text: "1",
            position: CustomSegmentLabelPosition.Outside,
            color: "#333333",
        },
        {
            text: "",
            position: CustomSegmentLabelPosition.Inside,
            color: "#555"
        },
        {
            text: "",
            position: CustomSegmentLabelPosition.Inside,
            color: "#555"
        },
        {
            text: "",
            position: CustomSegmentLabelPosition.Inside,
            color: "#555"
        },
        {
            text: "5",
            position: CustomSegmentLabelPosition.Outside,
            color: "#333333"
        }
    ];
    const dataTable = {
        headers: [
            {
                property: 'customerName',
                name: t('customersSurveyReportPage.customerName'),
                isName: true
            },
            {
                property: 'userEmail',
                name: 'Email',
                isEmail: true
            },
            {
                property: 'createdAt',
                name: t('customersSurveyReportPage.createdAt'),
                isDate: true
            },
            {
                property: 'csatScore',
                name: 'CSAT',
                isNumber: true
            },
            {
                property: 'npsScore',
                name: 'NPS',
                isNumber: true
            },
            {
                property: 'actions',
                name: '',
                isAction: true
            },
        ]
    };
    const [filterOptions, setFilterOptions] = useState<UniWidgetColumnTwoOptions[]>([{ value: new Date().getFullYear(), description: new Date().getFullYear() + '' }]);    
    const [customerSelectedValues, setCustomerSelectedValues] = useState<any>([]);
    const [reportData, setReportData] = useState<ResponseReportData>();
    const [filteredAvgCsatMonthsData, setFilteredAvgCsatMonthsData] = useState<UniWidgetColumnTwoOptions[]>([]);
    const [filteredAvgNpsMonthsData, setFilteredAvgNpsMonthsData] = useState<UniWidgetColumnTwoOptions[]>([]);
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [take, setTake] = useState<any>('10');
    const [page, setPage] = useState<number>(1);
    const [orderByColumnName, setOrderByColumnName] = useState('createdAt');
    const [orderByDirection, setOrderByDirection] = useState('desc');
    const [errorAccessAs, setErrorAccessAs] = useState('');
    const [showModalComment, setShowModalComment] = useState(false);
    const [currentModalComment, setCurrentModalComment] = useState('');

    useEffect(() => {
        getCustomersToFilter();
    },[]);

    useEffect(() => {
        onChangeFilterCsat(currentSelectedCsatFilter);
        onChangeFilterNps(currentSelectedNpsFilter);
    }, [i18n.language, reportData]);

    useEffect(() => {
        if(reportData) {
            getReport();
        }
    }, [take, page, orderByColumnName, orderByDirection]);

    const onChangeCustomerMulti = (e: MultiselectOptions[]) => {
        setCustomerSelectedValues(e.map(x => x.id));
    }    

    const getCustomersToFilter = () => {
        setLoading(true);
        getAllCustomer().then((customers)=> {
            setOptionsCustomers(customers.data.map(x => {
                return {
                    id: x.id,
                    name: x.issuerName
                }
            }) ?? []);
        })
        .catch(() => setOptionsCustomers([]))
        .finally(() => setLoading(false));
    }

    const onChangeDates = (dates: any) => {
        const [start, end] = dates;
        setPeriodValue(dateRange(start,end));
        setShowRangeDates(false);
        setStartDate(start);
        setEndDate(end);
        return;
    };

    const dateRange = (start: any, end: any) => {
        return moment(start).format('DD/MM/yyyy') + ' - ' + moment(end).format('DD/MM/yyyy');
    }

    const onChangeFilterCsat = (value: number) => {
        setCurrentSelectedCsatFilter(value);

        const filteredAvgCsatMonths = months.map(m => {
            const found = reportData?.avgCsatMonths.find(x => (x.month + '') === m.id && x.year === value);
            if (found) {
                return {
                    value: found.average,
                    description: t(m.name),
                    color: getAvgCsatMonthsColor(found.average)
                };
            }
            return {
                value: 0,
                description: t(m.name),
                color: '#EFEFEF'
            }
        });
        setFilteredAvgCsatMonthsData(filteredAvgCsatMonths);
    }

    const onChangeFilterNps = (value: number) => {
        setCurrentSelectedNpsFilter(value);

        const filteredAvgNpsMonths = months.map(m => {
            const found = reportData?.avgNpsMonths.find(x => (x.month + '') === m.id && x.year === value);
            if (found) {
                return {
                    value: found.average,
                    description: t(m.name),
                    color: getAvgNpsMonthsColor(found.average)
                };
            }
            return {
                value: 0,
                description: t(m.name),
                color: '#EFEFEF'
            }
        });
        setFilteredAvgNpsMonthsData(filteredAvgNpsMonths);
    }

    const getAvgCsatIcon = (average : number) => {
        if (average >= 1 && average < 2) {
            return FaceAngryRed;
        }
        if (average >= 2 && average < 3) {
            return FaceUpsetOrange;
        }
        if (average >= 3 && average < 4) {
            return FaceNeutralYellow;
        }
        if (average >= 4 && average < 5) {
            return FaceHappyLightgreen;
        }
        return FaceMarvelousGreen;
    }

    const getAvgCsatMonthsColor = (average : number) => {
        if (average >= 1 && average < 2) {
            return '#E23E44';
        }
        if (average >= 2 && average < 3) {
            return '#ED9A33';
        }
        if (average >= 3 && average < 4) {
            return '#EEC000';
        }
        if (average >= 4 && average < 5) {
            return '#9ED042';
        }
        return '#1BC76D';
    }

    const getAvgNpsMonthsColor = (average: number) => {
        if (average >= 1 && average < 2) {
            return '#FEE8A8';
        }
        if (average >= 2 && average < 3) {
            return '#F3CF5E';
        }
        if (average >= 3 && average < 4) {
            return '#EEC000';
        }
        if (average >= 4 && average < 5) {
            return '#DDB135';
        }
        return '#D3A107';
    }

    const getDataTableOrderBy = (property: string) => {
        if(property === 'actions') {
            return null;
        }

        if(orderByColumnName !== property) {
            return <FontAwesomeIcon icon={faSort} />
        }

        if(orderByDirection === 'desc') {
            return <FontAwesomeIcon icon={faSortAmountUp} />
        }

        return <FontAwesomeIcon icon={faSortAmountDown} />
    }

    const setDataTableOrderBy = (property: string) => {
        if(property === 'actions') {
            return
        }
        if(property === orderByColumnName) {
            setOrderByDirection(orderByDirection === 'desc' ? 'asc' : 'desc');
        } else {
            setOrderByDirection('asc');
        }
        setOrderByColumnName(property);
    }

    const isValidDate = () => {
        if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
            setErrorAccessAs(t('periodAlert.periodRequired'));
            return false;
        }

        if (isNaN(new Date(startDate).getTime()) || isNaN(new Date(endDate).getTime())) {
            setErrorAccessAs(t('periodAlert.invalidDate'));
            return false;
        }

        return true;
    }

    const mountPayload = () => {
        const request: RequestReportData = {
            customerIds: customerSelectedValues,
            startDate: moment(startDate).format('yyyy-MM-DD'),
            endDate: moment(endDate).format('yyyy-MM-DD'),
            take: take,
            page: page,
            orderByColumnName: orderByColumnName,
            orderByDirection: orderByDirection
        };

        let years: UniWidgetColumnTwoOptions[] = [];
        for (let index = Number(moment(startDate).format('yyyy')); index <= Number(moment(endDate).format('yyyy')); index++) {
            years.push({ value: index, description: index + '' });
        }
        setFilterOptions(years);

        return request;
    }

    const getReport = () => {
        if (!isValidDate()) {
            return;
        }

        setLoading(true);
        GetReportData(mountPayload())
            .then(m => {
                if (m.success) {
                    setReportData(m.data);                    
                    setTotalItems(m.data.tablePagesData[0].totalItems);
                    setTotalPages(m.data.tablePagesData[0].totalPages > 0 ? m.data.tablePagesData[0].totalPages : 1);
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
    }

    const openCommentModal = (comment: string) => {
        setShowModalComment(true);
        setCurrentModalComment(comment);
    }

    const downloadFile = async () => {
        if (!isValidDate()) {
            return;
        }
        setLoading(true);
        await GetFileReport(mountPayload(), i18n.language.toUpperCase()).finally(() => setLoading(false));
    }
    
    return (        
        <div className='customers-survey-report row'>
            <div className='filter-wrapper col-lg-4'>
                <div className='header'>
                    <div className='menu-icon'>
                        <img src={filterIcon} alt='icone de filtro' />
                    </div>
                    <div className='header'>
                        {t('filterData')}
                    </div>
                </div>
                <div className='body'>
                    <div className='filter'>
                        <Form.Label htmlFor='customers'>{t('customers')}</Form.Label>
                        <Multiselect
                            options={optionsCustomers}
                            onSelect={(e: any) => onChangeCustomerMulti(e)}
                            onRemove={(e: any) => onChangeCustomerMulti(e)}
                            displayValue='name'
                            placeholder={t('select')}
                            disable={loading}
                            hidePlaceholder
                            showCheckbox
                            showArrow
                        />
                    </div>

                    <div className='filter'>
                        <UniDatePickerRange
                            loading={loading}
                            periodValue={periodValue}
                            onChange={e => onChangeDates(e)}
                            options={[]}
                            onHideChange={() => setShowRangeDates(!showRangeDates)}
                        />
                    </div>

                    <div className='buttons-apply-filter'>
                        <Button
                            onClick={() => getReport()}
                            disabled={loading}
                            title={t('applyFilter')}
                        >
                            {t('applyFilter')}
                        </Button>
                    </div>
                </div>
            </div>
            { reportData && (
                <>                          
                    <div className='dois col-lg-8'>
                        <div className='row title-export-buttons'>
                            <div className='col report-title'>
                                <img src={graph} alt='graph' /> {t('viewingData')}
                            </div>
                            <div className='export-xls'>
                                <button disabled={loading} onClick={() => downloadFile()}>
                                    <img src={documentExcel} alt='documentExcel' /> {t('customersSurveyReportPage.exportXLS')}
                                </button>
                            </div>
                        </div>
                        <div className='row averages'>
                            <div className='col-lg-6 col-xl-4'>
                                <div className='row avg-csat'>
                                    <div className='col-lg-12 report-card'>
                                    {
                                        loading ? (
                                            <Skeleton
                                                height={144}
                                                highlightColor={'#f5f5f5'}
                                                baseColor={'#ebebeb'}
                                            />
                                        ) : (
                                            <UniWidgetSummaryReportTwo
                                                title={'CSAT'}
                                                subtitle={t('customersSurveyReportPage.avg')}
                                                iconImg={getAvgCsatIcon(reportData?.avgCsat[0]?.average ?? 0)}
                                                iconTotalImg={UserGroup}
                                                value={reportData?.avgCsat[0]?.average ?? 0}
                                                speedometerValue={(reportData?.avgCsat[0]?.average ?? 0) > 0 ? Math.floor(reportData?.avgCsat[0]?.average ?? 0) - 0.5 : 0}
                                                total={reportData?.avgCsat[0]?.count ?? 0}
                                                speedometerSegmentColors={["#E23E44", "#ED9A33", "#EEC000", "#9ED042", "#1BC76D"]}
                                                speedometerCustomSegmentLabels={speedometerCustomerSegmentLabels}
                                                speedometerMinValue={0}
                                                speedometerMaxValue={5}
                                            />
                                        )
                                    }
                                    </div>
                                </div>
                                <div className='row avg-nps'>                            
                                    <div className='col-lg-12 report-card'>
                                    {
                                        loading ? (
                                            <Skeleton
                                                height={144}
                                                highlightColor={'#f5f5f5'}
                                                baseColor={'#ebebeb'}
                                            />
                                        ) : (
                                            <UniWidgetSummaryReportTwo
                                                title={'NPS'}
                                                subtitle={t('customersSurveyReportPage.avg')}
                                                iconImg={StarYellow}
                                                iconTotalImg={UserGroup}
                                                value={reportData?.avgNps[0]?.average ?? 0}
                                                speedometerValue={(reportData?.avgNps[0]?.average ?? 0 ) > 0 ? Math.floor(reportData?.avgNps[0]?.average ?? 0) - 0.5 : 0}
                                                total={reportData?.avgNps[0]?.count ?? 0}
                                                speedometerSegmentColors={["#FEE8A8", "#F3CF5E", "#EEC000", "#DDB135", "#D3A107"]}
                                                speedometerCustomSegmentLabels={speedometerCustomerSegmentLabels}
                                                speedometerMinValue={0}
                                                speedometerMaxValue={5}
                                            />
                                        )
                                    }
                                    </div>
                                </div>
                            </div>
                            <div className='report-card col-lg-6 col-xl-8 avg-months'>
                                {
                                    loading ? (
                                        <Skeleton
                                            height={336}
                                            highlightColor={'#f5f5f5'}
                                            baseColor={'#ebebeb'}
                                        />
                                    ) : (
                                        <div className='tabs'>
                                            <div className='tab-header'>
                                                <div className={'tab' + (currentTab === 1 ? ' tab-active': '')} onClick={() => setCurrentTab(1)}>
                                                    CSAT - 
                                                    <span className='tab-subtitle'>{t('customersSurveyReportPage.avgMonth')}</span>
                                                </div>
                                                <div className={'tab' + (currentTab === 2 ? ' tab-active': '')}  onClick={() => setCurrentTab(2)}>
                                                    NPS - 
                                                    <span className='tab-subtitle'>{t('customersSurveyReportPage.avgMonth')}</span>
                                                </div>
                                            </div>
                                            {currentTab === 1 && (
                                                <UniWidgetColumnReportTwo
                                                    options={filteredAvgCsatMonthsData}
                                                    filterOptions={filterOptions}
                                                    onChangeFilter={onChangeFilterCsat}
                                                    currentSelectedFilter={currentSelectedCsatFilter}
                                                    columnReportHeight={185}
                                                    columnReportWidth={40}
                                                    maxValue={5}
                                                />
                                            )}
                                            {currentTab === 2 && (
                                                <UniWidgetColumnReportTwo
                                                    options={filteredAvgNpsMonthsData}
                                                    filterOptions={filterOptions}
                                                    onChangeFilter={onChangeFilterNps}
                                                    currentSelectedFilter={currentSelectedNpsFilter}
                                                    columnReportHeight={185}
                                                    columnReportWidth={40}
                                                    maxValue={5}
                                                />
                                            )}                                    
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className='tres col-lg-12'>                
                        <div className='report-card'>
                            {
                                loading ? (
                                        <Skeleton
                                            height={400}
                                            highlightColor={'#f5f5f5'}
                                            baseColor={'#ebebeb'}
                                        />
                                ) : (
                                    <div className='w-100 table-uni-wrapper'>
                                        <table className='table-uni'>
                                            <thead>
                                                <tr className='table-header'>
                                                    {
                                                        dataTable.headers.map(header => (
                                                            <th 
                                                                key={header.property} 
                                                                className={header.isNumber ? 'score' : header.isAction ? 'action' : ''}
                                                                onClick={()=> {setDataTableOrderBy(header.property)}}
                                                            >
                                                                {header.name}
                                                                {getDataTableOrderBy(header.property)}
                                                            </th>
                                                        ))
                                                    }
                                                </tr>
                                            </thead>
                                            {                                                
                                                reportData?.tableData?.length === 0 ? 
                                                (
                                                    <p className='w-100 text-center p-2'>
                                                        {t('searchNotFound')}
                                                    </p>
                                                ) : (
                                                    <tbody>
                                                        {
                                                            reportData?.tableData?.map((row: any, idx: number) => (
                                                                <tr key={idx} className='item-header'>
                                                                    {
                                                                        dataTable.headers.map(header => {
                                                                            if (header.isName || header.isEmail) {
                                                                                return (
                                                                                    <td key={header.property + idx}>{row?.[header.property]}</td>
                                                                                )
                                                                            }

                                                                            if (header.isNumber) {
                                                                                return (
                                                                                    <td key={header.property + idx} className='score'>{row?.[header.property] ?? '-'}</td>
                                                                                )
                                                                            }

                                                                            if (header.isDate) {
                                                                                return (
                                                                                    <td key={header.property + idx}>{row?.[header.property] ? `${moment(row?.[header.property]).format('DD/MM/yyyy HH:mm')}` : '-'}</td>
                                                                                )
                                                                            }

                                                                            if (header.property === 'actions') {
                                                                                return (
                                                                                    <td key={header.property + idx} className='action'>
                                                                                      <img src={EyeBlack} alt='icone de olhinho' onClick={() => openCommentModal(row?.comments)} />  
                                                                                    </td>
                                                                                );
                                                                            }

                                                                            return (
                                                                                <td key={header.property + idx} title={row?.[header.property]}>{row?.[header.property] ? row?.[header.property]?.length > 10 ? row?.[header.property]?.slice(0, 23) + '...' : row?.[header.property] : '-'}</td>
                                                                            )
                                                                        })
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                )
                                            }
                                        </table>
                                    </div>
                                )                        
                            }
                            <UniPagination 
                                totalItems={totalItems} 
                                totalPages={totalPages} 
                                changePage={(e) => setPage(e)} 
                                changeTake={(e) => { setPage(1); setTake(e) }}
                                currentTake={take}
                                currentPage={page}
                            />
                        </div>
                    </div>
                </>
            )}  
            <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={errorAccessAs}
                onHide={() => {setErrorAccessAs('')}}
                show={errorAccessAs !== ''}
                isFontAwsome
            />
            <UniModal 
                icon={ThreeStarsPointingFingerGreen}
                iconColor='#00FF3C'
                title={'Feedback'}
                message=''
                show={showModalComment}
                onHide={() => {
                    setShowModalComment(false);
                }}
                iconWidth={81}
                iconHeight={81}
            >
                <div className='modal-body-resume mx-4'>
                    <Form.Control as="textarea" rows={4} value={currentModalComment} readOnly/>
                </div>
            </UniModal>
        </div>
    );
}

export default CustomersSurveyReport;